import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/components/_contactform.scss';
import Swal from 'sweetalert2';

export default function ContactUsForm() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
  
    emailjs.sendForm(
      'service_6arwh0g',
      'template_4hbw0kb',
      form.current,
      '5fMJmzTKmGeuN3y9V'
    ).then(
      (result) => {
        Swal.fire({
          icon: 'success',
          title: 'Message sent!',
          text: 'Thank you for reaching out. We’ll get back to you soon.',
          confirmButtonColor: '#111',
        });
        form.current.reset();
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong. Please try again later.',
          confirmButtonColor: '#111',
        });
        console.error(error);
      }
    );
  };
  
  return (
    <form ref={form} onSubmit={sendEmail} className="contact-form">
  <div>
    <label>Full Name</label>
    <input type="text" name="full_name" required />
  </div>
  <div className="row">
    <div>
      <label>Email</label>
      <input type="email" name="user_email" required />
    </div>
    <div>
      <label>Phone</label>
      <input type="tel" name="phone" />
    </div>
  </div>
  <div>
    <label>Message</label>
    <textarea name="message" rows="4" required />
  </div>
  <button type="submit">→</button>
</form>

  );
}
